module.exports = __webpack_public_path__ + "static/media/ssublet.aab66f2d.jpg";